/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Info_PressInputs */

const en_footer_info_press = /** @type {(inputs: Footer_Info_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press / Media`)
};

/**
* | output |
* | --- |
* | "Press / Media" |
*
* @param {Footer_Info_PressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_info_press = /** @type {((inputs?: Footer_Info_PressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Info_PressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_info_press(inputs)
});